import { render, staticRenderFns } from "./retentionCom.vue?vue&type=template&id=de11d4ba&scoped=true"
import script from "./retentionCom.vue?vue&type=script&lang=js"
export * from "./retentionCom.vue?vue&type=script&lang=js"
import style0 from "./retentionCom.vue?vue&type=style&index=0&id=de11d4ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de11d4ba",
  null
  
)

export default component.exports